<template>
  <div :class="`form-element-viewer ${type}-viewer`">
    <template v-if="value === true || value === false">
      {{ value ? trueLabel : falseLabel }}
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: null },
    type: { type: String, required: true },
    options: { type: Object, required: true }
  },
  computed: {
    trueLabel () {
      if (this.options.answer_pair === 'custom') {
        return this.options.custom_true;
      } else {
        return this.$t('form.elements.checkbox.answer_pairs.' + this.options.answer_pair + '.true');
      }
    },
    falseLabel () {
      if (this.options.answer_pair === 'custom') {
        return this.options.custom_false;
      } else {
        return this.$t('form.elements.checkbox.answer_pairs.' + this.options.answer_pair + '.false');
      }
    }
  }
};
</script>
